import { takeLatest, call, put, all } from 'redux-saga/effects';
import axios from 'axios';
import axiosRetry from 'axios-retry';

import { deactivateSuccess, deactivateFailure } from './deactivate.actions';
import { DeactivateActionTypes, DeactivateStart } from './deactivate.types';

axiosRetry(axios, { retries: 2 });

const deactivate = async (messageId: string, programmatic: boolean | undefined) => {
    if (programmatic) {
        await axios.post<any>(`${process.env.REACT_APP_DEACTIVATOR_API}/deactivator/v1/deactivate/programmatic/trigger`, {
            messageId
        });
    } else {
        await axios.post<any>(`${process.env.REACT_APP_DEACTIVATOR_API}/deactivator/v1/deactivate/trigger`, {
            messageId
        });
    }
};

export function* deactivateSagaAsync(action: DeactivateStart) {
    try {
        const { messageId, programmatic } = action.payload;
        yield deactivate(messageId, programmatic);
        yield put(
            deactivateSuccess({
                isDeactivated: true
            })
        );
    } catch (error: any) {
        yield put(
            deactivateFailure({
                errorMessage: error.message
            })
        );
    }
};

export function* deactivateSaga() {
    yield takeLatest(DeactivateActionTypes.DEACTIVATE_START, deactivateSagaAsync)
};

export function* deactivateSagas() {
    yield all([
        call(deactivateSaga),
    ]);
};
